<template>
  <div class="my-footer">
    <swiper :options="swiperOptions">
      <swiper-slide v-for="(item, i) in histroy" :key="'list' + i">
        <div class="flex target">
          <div>
           <!-- <img class="img" src="" alt="" /> -->
          </div>
          <div class="item flex flex-direction">
			   <!-- <span class="name">{{ item.name }}</span> -->
            <div class="number">{{ item.num }} <span class="uuid">{{ item.unit }}</span></div>
            <!-- <animate-number
              from="0"
              :to="item.num"
              :key="item.num"
              class="number"
            ></animate-number> -->
            <div class="flex">
              <div class="name">{{ item.name }}</div>
             
            </div>
          </div>
        </div>
      </swiper-slide>
    </swiper>
  </div>
</template>

<script>
// import { fontSize48 } from './comm'
import { dataInterface } from "@/api/dataInterfaceApi";
export default {
  data() {
    return {
      histroy: [
        {
          name: "南京浦口算力中心",
          num: 0,
          unit: "P",
        },
        {
         name: "苏州相城算力中心",
         num: 0,
         unit: "P",
        },
        {
          name: "苏州汾湖算力中心",
          num: 0,
          unit: "P",
        },
        {
         name: "丽水青田算力中心",
         num: 0,
         unit: "P",
        },
        {
          name: "北京浦口算力中心",
          num: 0,
          unit: "P",
        },
        {
          name: "南京浦口算力中心",
          num: 0,
          unit: "P",
        },
      ],
      swiperOptions: {
        loop: true,
        autoplay: {
          delay: 2000,
          disableOnInteraction: false,
        },
        speed: 500,
        slidesPerView: 5,
        spaceBetween: 140,
        centeredSlides: true,
        watchSlidesProgress: true,
        // on: {
        //   setTranslate: function () {
        //     let slides = this.slides;
        //     for (let i = 0; i < slides.length; i++) {
        //       let slide = slides.eq(i);
        //       let progress = slides[i].progress;
        //       slide.css({
        //         opacity: "",
        //         background: "",
        //       });
        //       slide.transform("");
        //       slide.css("opacity", 1 - Math.abs(progress) / 6);
        //       slide.transform(
        //         "translate3d(0," + Math.abs(progress) * 20 + "px, 0)"
        //       );
        //     }
        //   },
        //   setTransition: function (transition) {
        //     for (let i = 0; i < this.slides.length; i++) {
        //       let slide = this.slides.eq(i);
        //       slide.transition(transition);
        //     }
        //   },
        // },
      },
    };
  },
  mounted() {
    this.zongheAll();
  },
  methods: {
    // 综合态势累计
    zongheAll() {
      let params = {
        enCode: "powerplant-left-ljcyfhtjqk",
      };
      dataInterface
        .dataFaceApi(params)
        .then((res) => {
          // console.log(res, "历史参与与负荷调节情况");
          this.histroy[0].num = Number(res[0].acc_active_num).toFixed(0) || 0;
          this.histroy[1].num = Number(res[0].acc_finish_num).toFixed(0) || 0;
          this.histroy[2].num =
            Number(res[0].finish_rate).toFixed(0)  || "0";
          this.histroy[3].num =
            Number(res[0].acc_subsidy).toFixed(0)  || "0";
          this.histroy[4].num =
            Number(res[0].cumulative_response_capacity).toFixed(0) || 0;
          this.histroy[5].num = Number(res[0].carbon_reduction).toFixed(0) || 0;
        })
        .catch((err) => {
          console.log(err);
        });
    },
  },
};

</script>

<style lang="scss"  scoped>
@import "./comm.scss";
.my-footer {
  .swiper-container {
    height: 100%;
    // background-color: pink;
    width: 2219px;
    // height: 215.37px;
    .swiper-wrapper {
      // margin-top: 40px;
    }
  }

  .swiper-slide {
    .item-c-at {
      display: none;
    }
  }

  .swiper-slide-active {
    .item {
      .item-c {
        display: none;
      }

      .item-c-at {
        display: block;
      }

      .item-l {
        font-size: $FontSize36;
      }

      .item-v {
        height: 120px;
        margin-top: -80px;

        > span {
          color: #00fdf4;
          font-size: $FontSize96;
        }
      }
    }
  }

  .target {
	// margin-top: 20px;
    width: 497px;
    height: 157px;
	// padding-top: 10px;
	background: url("~@/assets/images/exposition/suanlizhongxin.png") no-repeat;
   

    .item {
		position: relative;
	      // margin-top: 40px;
      // margin-left: -120px;

      .number {
		 
		  width: 100%;
		 
		  
		  text-align: center;
		   // height: 83px;
        // color: #00fdf4;
        font-size: $FontSize36;
         // font-family: 'HT';
        padding-left: 50px;
		font-weight: bold;
		// background-color: lightblue;
		// padding-bottom: 10px;
		
      }
      .name {
		  // padding-top: 40px;
		  display: block;
		  font-weight: bold;
		  // background-color: gray;
		  height: 74px;
		  text-align: center;
		   font-size: $FontSize38;
           padding-left: 55px;
      }
      
      .uuid {
        // display: block;
        color: #fff;
        height: 40px;
        line-height: 20px;
        // padding-left: 30px;
        font-size: $FontSize36;
      }
    }
  }
}
</style>